import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Carousel = props => (
	<Slider
		dots={props.dots || false}
		infinite={props.infinite === undefined ? true : props.infinite}
		arrows={props.arrows === undefined ? true : props.arrows}
		speed={props.speed || 500}
		slidesToShow={props.slidesToShow || 1}
		slidesToScroll={props.slidesToScroll || 1}
		autoplay={props.autoplay !== undefined ? props.autoplay : true}
		{...props}>
		{props.children}
	</Slider>
)

export default Carousel
